import * as React from 'react'
import styled from '../../../../theme/styled'
import classNames from 'classnames'

const Unit = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: normal;
`

const ErrorMsg = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.error};
  padding-bottom: 1em;
`

export type UnitConfig = {
  title: string
  unit: string
}

const UnitInput = props => {
  const { input, meta, title, unit, className, ...rest } = props
  return (
    <div>
      <label
        htmlFor={input.name}
        className={classNames({ 'read-only-value': rest.disabled })}
      >
        {title}
        <input
          className={classNames(className, {
            'with-units': true,
            error: meta.touched && meta.error
          })}
          {...input}
          {...rest}
        />
        <Unit>{unit}</Unit>
      </label>
      {meta.touched && meta.error && <ErrorMsg>{meta.error}</ErrorMsg>}
    </div>
  )
}
export default UnitInput



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/Inputs/UnitInput.tsx